<template>
  <header class="ref-header" :class="{ 'ref-header--warm': warm }">
    <div class="ref-header__side">
      <slot name="left">
        <button v-if="back" class="ref-icon-button" :aria-label="$t('frontend.common.back')" @click="goBack">
          <van-icon name="arrow-left" />
        </button>
      </slot>
    </div>
    <h1 class="ref-header__title"><slot>{{ title }}</slot></h1>
    <div class="ref-header__side ref-header__side--right">
      <slot name="right">
        <!-- 右上角客服入口暂时隐藏，保留代码便于恢复。
        <router-link v-if="service" to="/ServiceOnline" class="ref-icon-button" aria-label="線上客服">
          <van-icon name="service-o" />
        </router-link>
        -->
      </slot>
    </div>
  </header>
</template>
<script>
export default {
  props: {
    title: { type: String, default: "" },
    back: Boolean,
    warm: Boolean,
    service: { type: Boolean, default: true }
  },
  methods: {
    goBack() {
      if (window.history.length > 1) this.$router.back();
      else this.$router.push("/Home");
    }
  }
};
</script>
